module.exports = __webpack_public_path__ + "img/index_qklcz_b.0bd9b1f2.webp";